import { ErrorMessage } from 'components/1-atoms/ErrorMessage';
import { CheckboxList, CheckboxListOption, RadioButtonList, RadioButtonListOption } from 'components/2-molecules/Form';
import { TravelDeductionFormData, TravelDeductionStepState } from '../TravelDeduction';
import styles from './ConditionStep.module.scss';

export interface ConditionStepFieldText {
	question: string;
	optionsAriaLabel: string;
	options: RadioButtonListOption[] | CheckboxListOption[];
	helpTextHeader?: string;
	helpText?: string;
}
export interface ConditionStepProps {
	register: { (name: string, { required }: TravelDeductionStepState) };
	savedData?: TravelDeductionFormData;
	showPaymentBridges: boolean;
	showTransportTypes: boolean;
	specialAddress: ConditionStepFieldText;
	paymentBridgeUsage: ConditionStepFieldText;
	paymentBridges: ConditionStepFieldText;
	transportTypes: ConditionStepFieldText;
	paymentBridgeBothWays: ConditionStepFieldText;
}

export const ConditionStep = ({
	register,
	savedData,
	showPaymentBridges,
	showTransportTypes,
	specialAddress,
	paymentBridgeUsage,
	paymentBridges,
	transportTypes,
	paymentBridgeBothWays,
}: ConditionStepProps) => {
	const getOptions = (dataOptions: RadioButtonListOption[], savedOption: string | string[]) => {
		if (!savedOption) return dataOptions;
		return dataOptions?.map((option) => {
			option.value === savedOption ? (option.checked = true) : (option.checked = false);
			return option;
		});
	};

	return (
		<div className={styles.ConditionStep}>
			<RadioButtonList
				{...specialAddress}
				options={getOptions(specialAddress?.options, savedData?.specialAddress)}
				name="specialAddress"
				register={register}
			/>
			<RadioButtonList
				{...paymentBridgeUsage}
				options={getOptions(paymentBridgeUsage?.options, savedData?.paymentBridgeUsage)}
				name="paymentBridgeUsage"
				register={register}
			/>

			{showPaymentBridges && (
				<CheckboxList
					{...paymentBridges}
					options={getOptions(paymentBridges.options as CheckboxListOption[], savedData?.paymentBridges)}
					name="paymentBridges"
					register={register}
				/>
			)}
			{showTransportTypes && (
				<>
					<RadioButtonList
						{...transportTypes}
						options={getOptions(transportTypes?.options, savedData?.transportType)}
						name="transportType"
						register={register}
						state={ErrorMessage ? { required: true } : { required: true }}
					/>
					<RadioButtonList
						{...paymentBridgeBothWays}
						options={getOptions(paymentBridgeBothWays?.options, savedData?.paymentBridgeBothWays)}
						name="paymentBridgeBothWays"
						register={register}
						state={ErrorMessage ? { required: true } : { required: true }}
					/>
				</>
			)}
		</div>
	);
};
